import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaseStudyHeaderComponent } from './case-study-header.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [CaseStudyHeaderComponent],
  imports: [CommonModule, SharedModule],
  exports: [CaseStudyHeaderComponent],
})
export class CaseStudyHeaderModule {}
